import { CALL_API } from "../../middlewares/api";
import { get_terminated_loans } from "./terminatedLoansActions";

export const COLLECTION_FILES_REQUEST = "COLLECTION_FILES_REQUEST";
export const COLLECTION_FILES_SUCCESS = "COLLECTION_FILES_SUCCESS";
export const COLLECTION_FILES_ERROR = "COLLECTION_FILES_ERROR";

export function load_files() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/debt-agency/list-request-batches-collection",
      authenticatedRequest: true,
      method: "GET",
      types: [
        COLLECTION_FILES_REQUEST,
        COLLECTION_FILES_SUCCESS,
        COLLECTION_FILES_ERROR,
      ],
    },
  };
}

export const COLLECTION_CREATE_FILES_REQUEST =
  "COLLECTION_CREATE_FILES_REQUEST";
export const COLLECTION_CREATE_FILES_SUCCESS =
  "COLLECTION_CREATE_FILES_SUCCESS";
export const COLLECTION_CREATE_FILES_ERROR = "COLLECTION_CREATE_FILES_ERROR";

export function create_files() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/debt-agency/build-collection-request-batch",
      authenticatedRequest: true,
      method: "POST",
      types: [
        COLLECTION_CREATE_FILES_REQUEST,
        { method: filesCreated },
        COLLECTION_CREATE_FILES_ERROR,
      ],
    },
  };
}

function filesCreated(response) {
  return (dispatch) => {
    dispatch({ type: COLLECTION_CREATE_FILES_SUCCESS, response });
    dispatch(load_files());
    dispatch(get_terminated_loans());
  };
}

export const COLLECTION_LOAD_FILE_DETAILS_REQUEST =
  "COLLECTION_LOAD_FILE_DETAILS_REQUEST";
export const COLLECTION_LOAD_FILE_DETAILS_SUCCESS =
  "COLLECTION_LOAD_FILE_DETAILS_SUCCESS";
export const COLLECTION_LOAD_FILE_DETAILS_ERROR =
  "COLLECTION_LOAD_FILE_DETAILS_ERROR";

export function load_file_details(id) {
  return {
    [CALL_API]: {
      method: "GET",
      endpoint: "/api/admin/debt-agency/request-batch-details?BatchId=" + id,
      authenticatedRequest: true,
      data: { BatchId: id },
      types: [
        COLLECTION_LOAD_FILE_DETAILS_REQUEST,
        COLLECTION_LOAD_FILE_DETAILS_SUCCESS,
        COLLECTION_LOAD_FILE_DETAILS_ERROR,
      ],
    },
  };
}

export const COLLECTION_FINALIZE_FILE_REQUEST =
  "COLLECTION_FINALIZE_FILE_REQUEST";
export const COLLECTION_FINALIZE_FILE_SUCCESS =
  "COLLECTION_FINALIZE_FILE_SUCCESS";
export const COLLECTION_FINALIZE_FILE_ERROR = "COLLECTION_FINALIZE_FILE_ERROR";

export function finalize_file(id) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/debt-agency/finalize-batch",
      authenticatedRequest: true,
      method: "POST",
      data: { BatchId: id },
      types: [
        COLLECTION_FINALIZE_FILE_REQUEST,
        COLLECTION_FINALIZE_FILE_SUCCESS,
        COLLECTION_FINALIZE_FILE_ERROR,
      ],
    },
  };
}

export const COLLECTION_REMOVE_LOAN_FROM_FILE_REQUEST =
  "COLLECTION_REMOVE_LOAN_FROM_FILE_REQUEST";
export const COLLECTION_REMOVE_LOAN_FROM_FILE_SUCCESS =
  "COLLECTION_REMOVE_LOAN_FROM_FILE_SUCCESS";
export const COLLECTION_REMOVE_LOAN_FROM_FILE_ERROR =
  "COLLECTION_REMOVE_LOAN_FROM_FILE_ERROR";

export function remove_loan_form_file(fileId, loanId) {
  const data = { BatchId: fileId, LoanId: loanId };
  return {
    [CALL_API]: {
      endpoint: "/api/admin/debt-agency/remove-from-batch",
      authenticatedRequest: true,
      data,
      method: "POST",
      types: [
        COLLECTION_REMOVE_LOAN_FROM_FILE_REQUEST,
        { method: loanRemoved.bind(this, data) },
        COLLECTION_REMOVE_LOAN_FROM_FILE_ERROR,
      ],
    },
  };
}
function loanRemoved(dataSent, response) {
  return (dispatch) => {
    dispatch({
      type: COLLECTION_REMOVE_LOAN_FROM_FILE_SUCCESS,
      response,
      dataSent,
    });
    dispatch(get_terminated_loans());
  };
}
